
import { defineComponent, PropType } from 'vue'
import { AgentAction } from '~/types/types'
import { parseISODate, formatDate } from '~/utils/date'

export default defineComponent({
  name: 'AgentActionCardPending',
  props: {
    action: {
      type: Object as PropType<AgentAction>,
      required: true
    }
  },
  computed: {
    formatActionDate() {
      return formatDate(parseISODate(this.action?.createdAt), 'lll')
    }
  }
})
